// FundAllocationTable.js
import React from 'react';
import { useTranslation } from 'react-i18next';
//import DOMPurify from 'dompurify';
//import './FundAllocationTable.css';
import jsonpath from 'jsonpath';

const FundAllocationTable = ({ fundData = {}, isTableExpandedByDefault = false }) => {

    const { t } = useTranslation();

    const data = (fundData && fundData.FundDataValues && Array.isArray(fundData.FundDataValues)) ? fundData.FundDataValues : [];

    const getClassificationTypes = ( ) => {
        if (!data || typeof data !== 'object' || Object.keys(data).length === 0) {
          return [];
        }
      
        let classificationTypes = jsonpath.query(data, '$..ClassificationType');
      
        // Remove duplicates and sort alphabetically
        classificationTypes = [...new Set(classificationTypes)].sort();
      
        return classificationTypes;
    };

    const dropdownValues = getClassificationTypes();

    const expandedClass = isTableExpandedByDefault ? "is-active" : "";

    if (!data || data.length === 0) {
        return <div>Loading...</div>; 
    }

    return (
        <>
            <div className="l-container funds-allocator">
                <div className={`portfolio-content u-margin-left-30-small-up u-margin-right-30-small-up u-margin-left-20-small-down u-margin-right-20-small-down ${expandedClass}`}>
                    <div className="l-grid__row justify-content-center">
                        <div className="l-grid__column-6 l-grid__column-medium-6 l-grid__column-small-12 u-padding-top-lg">
                            <h6 className="c-heading u-padding-top-md" tabIndex="0">{t('individualFundsLabel')}</h6>
                        </div>
                        <div className="l-grid__column-6 l-grid__column-medium-6 l-grid__column-small-12 u-padding-top-lg">
                            <div className="l-grid__row">
                                <div className="l-grid__column-6 l-grid__column-large-6 u-hidden-medium-down u-text-align-right">
                                    <p className="c-copy u-margin-top-m" tabIndex="0">{t('fundTypeSelectorLabel')}</p>
                                </div>
                                <div className="l-grid__column-6 l-grid__column-large-6 l-grid__column-medium-12 l-grid__column-small-12 portfolio-sorting">
                                    <div className="c-select js-select u-margin-bottom-2m c-natural-language-form__form-body__selector c-natural-language-form__form-body__selector--long js-natural-form-selector-handler">
                                        <select className="c-select__natural"
                                                name="select-1"
                                                aria-hidden="false"
                                                data-label={t('dropdownCaptionLabel')}
                                                id="assetSortSelect">

                                            {dropdownValues.map((fundType, index) => (
                                                <option 
                                                    key={index} 
                                                    value={fundType} 
                                                    data-filter={fundType} 
                                                    id={`fundSelect-${index}`}>
                                                    {fundType}
                                                </option>
                                            ))}

                                            <option value={t('allLabel')}
                                                    data-filter="all"
                                                    id={`fundSelect-${dropdownValues.length}`}>
                                                {t('allLabel')}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="l-grid__row justify-content-center">
                        <div className="l-grid__column-12 l-grid__column-medium-12 l-grid__column-small-12">
                            <table className="c-table c-table--agi has-border c-table--sortable c-table--compact-header js-portfolio-sort">
                                <thead>
                                    <tr className="c-table__header__row" tabIndex="0">
                                        <th className="c-table__header__cell c-table__header__cell--sortable c-table--sortable c-table--compact-header" data-sort="type" tabIndex="0">
                                            <div className="c-table__header-wrapper">
                                                <span className="c-table__sort-indicator">
                                                    <i className="c-icon c-icon--chevron-up" aria-hidden="true"></i>
                                                    <i className="c-icon c-icon--chevron-down u-line-height-0 " aria-hidden="true"></i>
                                                </span>
                                                <span className="c-table__header__title" tabIndex="0">{t('tableColumnShareLabel')}</span>
                                            </div>
                                        </th>

                                        <th className="c-table__header__cell c-table__header__cell--sortable c-table--sortable c-table--compact-header" data-sort="name" tabIndex="0">
                                            <div className="c-table__header-wrapper">
                                                <span className="c-table__sort-indicator">
                                                    <i className="c-icon c-icon--chevron-up" aria-hidden="true"></i>
                                                    <i className="c-icon c-icon--chevron-down u-line-height-0 " aria-hidden="true"></i>
                                                </span>
                                                <span className="c-table__header__title" tabIndex="0">{t('tableColumnFundNameLabel')}</span>
                                            </div>
                                        </th>

                                        <th className="c-table__header__cell c-table__header__cell--sortable c-table--sortable c-table--compact-header" data-sort="allotment" tabIndex="0">
                                            <div className="c-table__header-wrapper">
                                                <span className="c-table__sort-indicator">
                                                    <i className="c-icon c-icon--chevron-up" aria-hidden="true"></i>
                                                    <i className="c-icon c-icon--chevron-down u-line-height-0 " aria-hidden="true"></i>
                                                </span>

                                                <span className="c-table__header__title" tabIndex="0">{t('tableColumnShareCaption')}</span>
                                            </div>
                                        </th>
                                        <th className="opener" tabIndex="0">
                                            <span className="mini-portrait-opener"></span>
                                        </th>
                                    </tr>
                                </thead>
                            </table>
                            <ul id="portfolio-accordion" className="c-agi-accordion c-portfolio-accordian c-portfolio-accordian-toggle js-agi-accordion" data-autocollapse="false">
                                {data.map((fundValue, index) => (
                                    <li key={index} className={`c-agi-accordion__item ${fundValue?.ClassificationType}`} data-type={fundValue?.ClassificationType} data-allotment={fundValue?.ValuePercentageFormatted} data-name={fundValue?.name}>
                                        <button aria-controls="tab-content-1" className="c-agi-accordion__button">
                                            <span className="accordian-label">
                                                <span className="justify-content-start u-margin-none">{fundValue?.name}</span>
                                                <span className="justify-content-end u-margin-none c-percent">{fundValue?.ValuePercentageFormatted}</span>
                                            </span>
                                        </button>
                                        <div className="c-agi-accordion__content" aria-labelledby="tab-content-1">
                                            <h3 className="u-heading u-margin-bottom-2m">{fundValue?.name}</h3>
                                            <p className="c-copy u-margin-bottom-2m">{fundValue?.FundCharacteristics}</p>
                                            <div className="l-grid__row">
                                                <div className="l-grid__column-1 l-grid__column-medium-1 u-text-align-center u-padding-right-none u-hidden-medium-down">
                                                    <div className="pie-wrapper accordian-circle" data-type={fundValue?.ClassificationType} data-allotment={fundValue?.Value} data-title={fundValue?.ValuePercentageFormatted}>
                                                    </div>
                                                </div>
                                                <div className="c-image-accordian l-grid__column-1 l-grid__column-medium-1 u-text-align-center u-hidden-medium-down">
                                                {fundValue.FundManagers && fundValue.FundManagers.length > 0 && fundValue.FundManagers[0].FundManagerImage &&
                                                    <picture className="c-image c-image--rounded ">
                                                        <img src={fundValue.FundManagers[0].FundManagerImage?.src} className="c-image__img" alt={fundValue.FundManagers[0].Name} />
                                                    </picture>
                                                }
                                                </div>
                                                <div className="l-grid__column-10 l-grid__column-medium-10 l-grid__column-small-12">
                                                   {fundValue.FundManagers && fundValue.FundManagers.length > 0 &&
                                                    <>
                                                        <h3 className="u-heading u-margin-bottom-none">{fundValue.FundManagers[0].Name}</h3>
                                                        <p className="c-copy u-margin-top-none u-margin-bottom-m">{t('fundManagerLabel')}</p>
                                                    </>
                                                    }
                                                    <p className="c-copy u-margin-top-m 0-margin-bottom-none" tabIndex="0">{fundValue.InvestmentObjective}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="l-grid__row justify-content-center">
                    <div className="l-grid__column-12 u-text-align-center u-margin-top-m">
                        {/* eslint-disable-next-line */}
                        <a className={`c-link c-link--block u-margin-top-m c-link--icon ${isTableExpandedByDefault ? 'u-hidden' : ''} open-detailed-view`} tabIndex="0" href="#" aria-label="">
                            <span aria-hidden="true" className="c-link__icon c-icon c-icon--arrow-down"></span>
                            <span className="c-link__text">Open detail view</span>
                        </a>
                        {/* eslint-disable-next-line */}                        
                        <a className={`c-link c-link--block u-margin-top-m c-link--icon ${!isTableExpandedByDefault ? 'u-hidden' : ''} close-detailed-view`} tabIndex="0" href="#" aria-label="">
                            <span aria-hidden="true" className="c-link__icon c-icon c-icon--arrow-up"></span>
                            <span className="c-link__text">Close detail view</span>
                        </a>
                    </div>
                </div>
            </div>
        </>
    )
}

export default FundAllocationTable;